import { gql } from '@apollo/client';

export const GET_PROJECT_APPLICATION_SETTINGS = gql`
  query GET_PROJECT_APPLICATION_SETTINGS(
    $state: State
    $showPriorities: [Int!]
  ) {
    projectApplicationSettings(state: $state, showPriorities: $showPriorities) {
      id
      code
      title
      description
      showPriority
      deadlineOfUsingUpFunding
      startDate
      endDate
      approvedFundingSource {
        id
        name
      }
      additionalFundingSource {
        id
        name
      }
      disabled
      deleted
    }
  }
`;

export const UPDATE_PROJECT_APPLICATION_SETTING = gql`
  mutation UPDATE_PROJECT_APPLICATION_SETTING(
    $input: UpdateProjectApplicationSettingInput!
  ) {
    updateProjectApplicationSetting(input: $input) {
      id
      code
      title
      description
      showPriority
      startDate
      endDate
      disabled
      deleted
    }
  }
`;

export const DELETE_PROJECT_APPLICATION_SETTING = gql`
  mutation DELETE_PROJECT_APPLICATION_SETTING($id: ID!) {
    deleteProjectApplicationSetting(id: $id) {
      id
      code
      title
      disabled
      deleted
    }
  }
`;

export const FRAGMENT_ROLE_HIERARCHY_DATA = gql`
  fragment roleHierarchyData on RoleHierarchy {
    role {
      name
      id
    }
    sequence
    level
  }
`;

export const ADD_PROJECT_APPLICATION_SETTING = gql`
  ${FRAGMENT_ROLE_HIERARCHY_DATA}

  mutation ADD_PROJECT_APPLICATION_SETTING(
    $input: AddProjectApplicationSettingInput!
  ) {
    addProjectApplicationSetting(input: $input) {
      id
      code
      title
      startDate
      endDate
      description
      disabled
      deleted
      showPriority
      teamMemberMapping {
        name
        teamMemberType {
          id
          name
        }
      }
      roleHierarchy {
        department {
          ...roleHierarchyData
        }
        faculty {
          ...roleHierarchyData
        }
        school {
          ...roleHierarchyData
        }
        NAU {
          ...roleHierarchyData
        }
      }
    }
  }
`;

export const EDIT_PROJECT_APPLICATION_SETTING = gql`
  ${FRAGMENT_ROLE_HIERARCHY_DATA}

  mutation EDIT_PROJECT_APPLICATION_SETTING(
    $input: UpdateProjectApplicationSettingInput!
  ) {
    updateProjectApplicationSetting(input: $input) {
      id
      code
      title
      startDate
      endDate
      description
      disabled
      deleted
      showPriority
      teamMemberMapping {
        name
        teamMemberType {
          id
          name
        }
      }
      roleHierarchy {
        department {
          ...roleHierarchyData
        }
        faculty {
          ...roleHierarchyData
        }
        school {
          ...roleHierarchyData
        }
        NAU {
          ...roleHierarchyData
        }
      }
    }
  }
`;

export const GET_PROJECT_APPLICATION_SETTING = gql`
  ${FRAGMENT_ROLE_HIERARCHY_DATA}
  query GET_PROJECT_APPLICATION_SETTING($id: ID!) {
    projectApplicationSetting(id: $id) {
      id
      code
      title
      startDate
      endDate
      description
      disabled
      deleted
      deadlineOfUsingUpFunding
      showPriority
      approvedFundingSource {
        id
        name
      }
      additionalFundingSource {
        id
        name
      }
      teamMemberMapping {
        name
        teamMemberType {
          id
        }
      }
      roleHierarchy {
        department {
          ...roleHierarchyData
        }
        faculty {
          ...roleHierarchyData
        }
        school {
          ...roleHierarchyData
        }
        NAU {
          ...roleHierarchyData
        }
      }
    }
  }
`;
